// src/router/routerServices.ts

import { store } from "../store/store";

/**
 * ⚠️ Check if the user is authenticated.
 */
function isAuthenticated(): boolean {
    return !!store.state.user?.id;
}

/**
 * ✅ Remove the selected company from the store.
 */
export function removeSelectedCompany() {
    if (isAuthenticated() && store.state.selected_company) {
        store.commit("setCurrentCompany", null);
        console.log("[Router] ✅ Selected company removed.");
        return true;
    } else {
        console.warn("[Router] ⚠️ No selected company to remove.");
        return true;
    }
}

/**
 * ✅ Set the selected company from the URL.
 */
export const setSelectedCompanyFromUrl = (companyId: string) => () => {
    if (!isAuthenticated()) {
        console.warn("[Router] ⚠️ User is not authenticated.");
        return false;
    }

    if (companyId) {
        const company = store.getters.getCompany(companyId);
        if (company) {
            store.commit("setCurrentCompany", company);
            console.log(`[Router] ✅ Selected company set to: ${company.name}`);
            return true;
        } else {
            console.warn(`[Router] ⚠️ Company ID '${companyId}' not found.`);
            return false;
        }
    }
};

/**
 * ✅ Set the accounting firm from the store.
 */
export const setAccountingFirm = () => {
    try {
        if (!isAuthenticated()) {
            console.warn("[Router] ⚠️ User is not authenticated.");
            return false;
        }

        const accountingFirmId = store.state?.user?.company?.id as string | undefined;

        if (accountingFirmId) {
            store.commit("setCompanyAccountingFirm", { id: accountingFirmId });
            console.log(`[Router] ✅ Accounting firm set to ID: ${accountingFirmId}`);
            return true;
        } else {
            console.warn("[Router] ⚠️ No Accounting Firm ID provided in params.");
            return true;
        }
    } catch (error) {
        console.error("[Router] ❌ Error setting accounting firm:", error);
        return false;
    }
};

/**
 * ✅ Remove the accounting firm from the store.
 */
export function removeAccountingFirm() {
    if (isAuthenticated() && store.state.companyAccountingFirm) {
        store.commit("setCompanyAccountingFirm", null);
        console.log("[Router] ✅ Accounting firm removed.");
        return true;
    } else {
        console.warn("[Router] ⚠️ No accounting firm to remove.");
        return false;
    }
}
